"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetchRequest_1 = require("./fetchRequest");
var SalesProduct_1 = require("../api/SalesProduct");
var UrlParam_1 = require("../helpers/UrlParam");
var SalesProductConnector = /** @class */ (function () {
    function SalesProductConnector(baseUrl) {
        this.baseUrl = baseUrl;
    }
    /**
     * Get sales product with product name and party ID
     * @param partyId
     * @param productName
     * @param inheritanceUuid
     */
    SalesProductConnector.prototype.getSalesProduct = function (partyId, productName, inheritanceUuid) {
        var params = new URLSearchParams();
        UrlParam_1.appendParam(params, 'partyId', partyId);
        if (inheritanceUuid) {
            UrlParam_1.appendParam(params, 'inheritanceUuid', inheritanceUuid);
        }
        return fetchRequest_1.fetchWrappedRequest(SalesProduct_1.getSalesProductUsingGET(productName, params), this.baseUrl);
    };
    /**
     * Get all object gorups from a sales product
     * @param partyId
     * @param productName
     * @param inheritanceUuid
     */
    SalesProductConnector.prototype.getObjectGroups = function (partyId, productName, inheritanceUuid) {
        var params = new URLSearchParams();
        UrlParam_1.appendParam(params, 'partyId', partyId);
        if (inheritanceUuid) {
            UrlParam_1.appendParam(params, 'inheritanceUuid', inheritanceUuid);
        }
        return fetchRequest_1.fetchWrappedRequest(SalesProduct_1.getObjectGroupsUsingGET(productName, params), this.baseUrl);
    };
    /**
     * Get a specific object group from a sales product
     * @param partyId
     * @param productName
     * @param objectGroupName
     * @param inheritanceUuid
     */
    SalesProductConnector.prototype.getObjectGroup = function (partyId, productName, objectGroupName, inheritanceUuid) {
        var params = new URLSearchParams();
        UrlParam_1.appendParam(params, 'partyId', partyId);
        if (inheritanceUuid) {
            UrlParam_1.appendParam(params, 'inheritanceUuid', inheritanceUuid);
        }
        return fetchRequest_1.fetchWrappedRequest(SalesProduct_1.getObjectGroupUsingGET(productName, objectGroupName, params), this.baseUrl);
    };
    /**
     * Get object group details from a sales product
     * @param partyId
     * @param productName
     * @param objectGroupName
     * @param inheritanceUuid
     */
    SalesProductConnector.prototype.getObjectGroupDetails = function (partyId, productName, objectGroupName, inheritanceUuid) {
        var params = new URLSearchParams();
        UrlParam_1.appendParam(params, 'partyId', partyId);
        if (inheritanceUuid) {
            UrlParam_1.appendParam(params, 'inheritanceUuid', inheritanceUuid);
        }
        return fetchRequest_1.fetchWrappedRequest(SalesProduct_1.getObjectGroupDetailsUsingGET(productName, objectGroupName, params), this.baseUrl);
    };
    /**
     * Get detail from a sales product
     * @param partyId
     * @param productName
     * @param objectGroupName
     * @param detailId
     * @param inheritanceUuid
     */
    SalesProductConnector.prototype.getObjectGroupDetail = function (partyId, productName, objectGroupName, detailId, inheritanceUuid) {
        var params = new URLSearchParams();
        UrlParam_1.appendParam(params, 'partyId', partyId);
        if (inheritanceUuid) {
            UrlParam_1.appendParam(params, 'inheritanceUuid', inheritanceUuid);
        }
        return fetchRequest_1.fetchWrappedRequest(SalesProduct_1.getObjectGroupDetailUsingGET(productName, objectGroupName, detailId, params), this.baseUrl);
    };
    /**
     * Get detail instance from a sales product
     * @param partyId
     * @param productName
     * @param objectGroupName
     * @param detailId
     * @param inheritanceUuid
     */
    SalesProductConnector.prototype.getObjectGroupDetailInstance = function (partyId, productName, objectGroupName, detailId, inheritanceUuid) {
        var params = new URLSearchParams();
        UrlParam_1.appendParam(params, 'partyId', partyId);
        if (inheritanceUuid) {
            UrlParam_1.appendParam(params, 'inheritanceUuid', inheritanceUuid);
        }
        return fetchRequest_1.fetchWrappedRequest(SalesProduct_1.getObjectGroupDetailInstanceUsingGET(productName, objectGroupName, detailId, params), this.baseUrl);
    };
    return SalesProductConnector;
}());
exports.default = SalesProductConnector;
